import BaseMap from "../interfaces/BaseMap";
import IFilterSettings from "../interfaces/IFilterSettings";
import IGoogleTilesSession from "../interfaces/IGoogleTilesSession";
import IRecentItem from "../interfaces/IRecentItem";
import IRecentSearch from "../interfaces/IRecentSearch";
import ITokenPayload from "../interfaces/ITokenPayload";
import IViewState from "../interfaces/IViewState";
import IVisibleLayers from "../interfaces/IVisibleLayers";

export default class LocalStorageService {
    getTokenPayload(): ITokenPayload | null {
        const tokenPayloadJson = localStorage.getItem("authtoken");
        return tokenPayloadJson && JSON.parse(tokenPayloadJson);
    }

    setTokenPayload(tokenPayload: ITokenPayload) {
        localStorage.setItem("authtoken", JSON.stringify(tokenPayload));
    }

    removeTokenPayload() {
        localStorage.removeItem("authtoken");
    }

    getBaseMap(): BaseMap | null {
        const baseMapJson = localStorage.getItem("baseMap");
        return baseMapJson && JSON.parse(baseMapJson);
    }

    setBaseMap(value: BaseMap) {
        localStorage.setItem("baseMap", JSON.stringify(value));
    }

    getVisibleLayers(): IVisibleLayers | null {
        const visibleLayersJson = localStorage.getItem("visibleLayers");
        return visibleLayersJson && JSON.parse(visibleLayersJson);
    }

    setVisibleLayers(value: IVisibleLayers) {
        localStorage.setItem("visibleLayers", JSON.stringify(value));
    }

    getViewState(): IViewState | null {
        const viewStateJson = localStorage.getItem("viewState");
        return viewStateJson && JSON.parse(viewStateJson);
    }

    setViewState(value: IViewState) {
        localStorage.setItem("viewState", JSON.stringify(value));
    }

    getRecentSearches(key: string): IRecentSearch[] | null {
        const recentSearchesJson = localStorage.getItem(`recentSearches_${key}`);
        return recentSearchesJson && JSON.parse(recentSearchesJson);
    }

    setRecentSearches(key: string, value: IRecentSearch[]) {
        localStorage.setItem(`recentSearches_${key}`, JSON.stringify(value));
    }

    getRecentItems(key: string): IRecentItem[] | null {
        const recentItemsJson = localStorage.getItem(`recentItems_${key}`);
        return recentItemsJson && JSON.parse(recentItemsJson);
    }

    setRecentItems(key: string, value: IRecentItem[]) {
        localStorage.setItem(`recentItems_${key}`, JSON.stringify(value));
    }

    getUserEmail(): string | null {
        return localStorage.getItem("userEmail");
    }

    setUserEmail(value: string) {
        localStorage.setItem("userEmail", value);
    }

    clearUserEmail() {
        this.clearByKey("userEmail");
    }

    getPipedriveUserId(): number | null {
        const pipedriveUserIdString = localStorage.getItem("pipedriveUserId");
        return pipedriveUserIdString ? Number(pipedriveUserIdString) : null;
    }

    setPipedriveUserId(value: number) {
        localStorage.setItem("pipedriveUserId", value.toString());
    }

    clearPipedriveUserId() {
        this.clearByKey("pipedriveUserId");
    }

    getDefaultFilters(): IFilterSettings | null {
        const filterSettingsJson = localStorage.getItem("filterSettings");
        return filterSettingsJson && JSON.parse(filterSettingsJson);
    }

    setDefaultFilters(value: IFilterSettings) {
        localStorage.setItem("filterSettings", JSON.stringify(value));
    }

    getGoogleTilesSession(): IGoogleTilesSession | null {
        const json = localStorage.getItem("googleTilesSession");
        return json && JSON.parse(json);
    }

    setGoogleTilesSession(value: IGoogleTilesSession) {
        localStorage.setItem("googleTilesSession", JSON.stringify(value));
    }

    clearGoogleTilesSession() {
        this.clearByKey("googleTilesSession");
    }

    private clearByKey(key: string) {
        localStorage.setItem(key, "");
    }
}